import React, { Component } from 'react';

export default class Footer extends Component {
    constructor (props) {
        super(props);

        this.state = {
            client: '',
            environment: '',
            version: ''
        };
    }

    componentDidMount() {
        this.setState({
            client: (window.NODE_ENV === 'development' ? window.REACT_APP_CLIENT_NAME_DEV : window.REACT_APP_CLIENT_NAME_PROD) || '',
            environment: window.NODE_ENV || '',
            version: window.REACT_APP_VERSION || ''
        });
    }

    render() {
        return (
            <footer className="main-footer">
                <div className="pull-right">
                    {this.state.client} | {this.state.version}
                </div>
            </footer>
        );
    }
}